var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IOdometer',{attrs:{"id":"js__total","value":_vm.num,"format":"( ddd)","duration":1000}})}
var staticRenderFns = []

export { render, staticRenderFns }